export default "__VITE_PUBLIC_ASSET__4ff78dd1__"